<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  height: 100%;
  /* font-family: "microsoft yahei", "Avenir", Helvetica, Arial, sans-serif; */
  font-family: "Helvetica Neue", Helvetica, "PingFangSC-Regular",
    "PingFangSC-Medium", "PingFang SC Regular", "PingFang SC",
    "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  background-color: #f7f7f7;
}
</style>



// WEBPACK FOOTER //
// src/App.vue